export default __webpack_public_path__ + "static/media/Background 5_00007.07b55dad.png";